import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { useMediaQuery } from "@mui/material";
// import LoginLogo from "../../assets/images/png/LoginLogo.png"
import OTPInput, { ResendOTP } from "otp-input-react";
import LoginAunty from "../../assets/images/png/girlFile.png";
import LoginAuntyMobile from "../../assets/images/png/opt-mobile-screen.png";
import { FiChevronRight } from "react-icons/fi";
import i18n from "../../i18n";
import { useNavigate, useParams, Link, useHistory } from "react-router-dom";
import { BsX } from "react-icons/bs";
import "./fewMoreDetail.scss";
import englishUrduLogo from '../../assets/images/svg/englishUrduLogo.svg';
import Logo from "../../assets/images/png/meri-sehat-logo.png";
import encryptStorage from "../../utils/encryptStorage";
import { APIV3 } from "../../utils/customAxios";
import Loader from "../../uiComponents/loader/Loader";
import { maskPhone, CountryCodePhone } from "../../utils/helperFunctions";
import Cookies from "js-cookie";
import logo from "../../assets/images/svg/newDesign/logo.svg";
import call from "../../assets/images/svg/newDesign/call.svg";
import edit from "../../assets/images/svg/newDesign/edit.svg";
import logo1 from "../../assets/images/svg/newDesign/logo1.svg";

const DoctorSignInOtp = () => {
  const history = useHistory();
  const isMobile = useMediaQuery("(max-width:767px)");
  const [Otp, setOtp] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [url, setURL] = useState("");
  const [hideError, setHideError] = useState(false);
  const [apiLoading, setApiLoading] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [resendOtpError, setResendOtpError] = useState("");
  

  let phone = encryptStorage.getItem("maskedPhone");
  const networkLogin = encryptStorage.getItem("networkLogin");
  let maskedPhone = phone;

  let inputStyle = {
    height: "100px",
    width: "100px",
    borderRadius: "10px",
    marginRight: "0px",
  };

  const maskNumber = encryptStorage.getItem("phoneLogin");

  let maskContact = maskPhone(maskNumber);

  function handleSubmit(e) {
    e.preventDefault();

    if (Otp.length === 4) {
      (async () => {
        const phone = encryptStorage.getItem("phoneLogin");

        const data = {
          phone: `${phone}`,
          otp: Otp,
        };

        try {
          setApiLoading(true);
          const response = await APIV3.post("/doctor/doctor-otp", data);

          if (response?.status == 200) {
            setApiLoading(false);
            Cookies.set("token", response?.data?.data?.token, {
              expires: 30,
            });
            if (response?.data?.data?.is_signup == true) {
              window.location.href = '/signup-details'
            } else if (response?.data?.data?.is_signup == false && response?.data?.data?.is_live == false) {
              window.location.href = '/profile-setup'
            }
            else if (response?.data?.data?.is_signup == false && response?.data?.data?.is_live == true) {
              window.location.href = '/'
            }
          } else {
            setApiLoading(false);
            setOtpError(
              response?.data?.message || "Error! Something went wrong..."
            );
          }
        } catch (error) {
          setApiLoading(false);
          setOtpError(error?.response?.data?.message || error?.message);
        }
      })();
    } else {
      setOtpError("Enter OTP code");
    }
  }

  const renderInstantTime = (remainingTime) => {
    return (
      <span>
        {" "}
        {remainingTime === 0
          ? ""
          : ` 00:${remainingTime < 10 ? `0` : ""}${remainingTime} seconds`}
      </span>
    );
  };

  const renderInstantButton = (buttonProps) => {
    return (
      <button {...buttonProps}>
        {buttonProps.remainingTime === 0 ? (
          <>
            {" "}
            <a
              className="resendText"
              style={{color: "#19b3b5",borderBottom: '2px solid #19b3b5',}}
              onClick={resendOtpHandler}
            >
              Resend OTP
            </a>
            <br /> <p className="mt-1 fw-bold d-none"> Code Expired - Click Resend</p>{" "}
          </>
        ) : (
          "Resend OTP"
        )}
      </button>
    );
  };

  async function resendOtpHandler() {
    try {
      const phone = encryptStorage.getItem("phoneLogin");
      const data = {
        phone,
        otp_via : networkLogin,
      };

      const response = await APIV3.post("/doctor/resend-otp", data);

      if (response?.status == 200) {
        window.location.reload();
      } else {
        setResendOtpError(
          response?.data?.message || "Your OTP could not be resent..."
        );
      }
    } catch (error) {
      setResendOtpError(error?.response?.data?.message || error?.message);
    }
  }

  const editPhoneNumber = () => {
    Cookies.set('edit', "1")
    history.push('/login')
  }

  const isVerifyDisabled = !Otp || Otp.length < 4 || apiLoading;

  return (
    <>
      <StyledLoginOtp className="signup_otp">
        {apiLoading && <Loader />}
        {!isMobile &&
          <div className="header_meriSehat">
            <Container fluid>
              {apiLoading && <Loader />}
              <Row>
                <Col md={12}>
                  <div className="logo_only">
                    {/* <Link to="/"> */}
                    <img src={logo} className="logoEU" alt="Logo" />
                    {/* </Link> */}

                    <p className="phoneNumber"><img src={call} className="logoEU" alt="Logo" />(021)-111-111-111</p>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        }
        <Container>
          <Row>

            <Col xs={12} md={6} className="signup_otp_style mx-auto ">
              <div className="bg_custom">
                <div className="m-auto  text-center">
                  <img src={logo1} className="logoEU" alt="Logo" style={{ width: isMobile ? '220px' : '' }} />
                </div>

                {maskedPhone && (
                  <>
                    <div className="confirm-paragraph m-auto">
                      <p>
                        The verification code has been sent to {" "}

                      </p>
                      <div className="otpNumber">
                        <span className="num"> {maskedPhone} </span>
                        <span className="edit" style={{ cursor: 'pointer' }} onClick={editPhoneNumber} ><img src={edit}></img> Edit </span>

                      </div>
                    </div>

                  </>
                )}

                <form className="form" autoComplete="off" onSubmit={handleSubmit}>
                  <div className="px-md-4 otp-login-box">
                    <OTPInput
                      value={Otp}
                      onChange={setOtp}
                      autoFocus
                      hasErrored
                      OTPLength={4}
                      otpType="number"
                      disabled={false}
                      secure={false}
                      className={
                        otpError && !hideError
                          ? "input-otp-error otpContainer pb-0"
                          : "otpContainer" && resendOtpError && !hideError
                            ? "input-otp-error otpContainer pb-0"
                            : "otpContainer"
                      }
                      inputStyles={inputStyle}
                    />

                    {otpError && !hideError && (
                      <div
                        className="doctor-error-msg"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <p className="otpErrorState"> {otpError} </p>
                        {/* <BsX onClick={hideOtpError} className="bsX" /> */}
                      </div>
                    )}

                    {resendOtpError && !hideError && (
                      <div
                        className="doctor-error-msg"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <p> {resendOtpError} </p>
                        {/* <BsX onClick={hideOtpError} className="bsX" /> */}
                      </div>
                    )}

                    {/* </div> */}
                  </div>
                  <div className="resend-sms-otp px-4 mt-md-5 ">
                    <ResendOTP
                      maxTime={60}
                      className="OtpCounting"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        gap: "12px",
                      }}
                      renderButton={renderInstantButton}
                      renderTime={renderInstantTime}
                    //    onResendClick={resendOTPHandler}
                    />
                  </div>

                  <div className="Otp-continue-btn">
                    <button
                      type="submit"
                      disabled={isVerifyDisabled}
                      style={{ opacity: isVerifyDisabled ? '0.2' : '', color: isVerifyDisabled ? '#fff' : '' }}
                      className="review-button text-uppercase loginOtp-phone-btn position-relative"
                    >
                      Verify

                    </button>
                  </div>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </StyledLoginOtp>
    </>
  );
};

export const StyledLoginOtp = styled.section`
  /* position: relative; */
  .LogoStyled {
    padding-top: 55px;
  }

  .heading-confirm {
    text-align: center;
    // padding: 0 175px;

    h3 {
      font-family: 'Satoshi-Medium';
      font-style: normal;
      font-weight: 500;
      font-size: 32px;
      line-height: 42px;
      /* or 125% */

      display: flex;
      align-items: center;
      text-align: center;

      color: #313131;
    }
  }

  .confirm-paragraph {
    text-align: center;

    span {
      font-family: 'Satoshi-Medium';
      font-style: normal;
      font-weight: 450;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      color: #313131;
    }
  }

  .otp-font {
    font-family: 'Satoshi-Regular';
    font-style: normal;
    font-weight: 400;
    font-size: 40px;
    line-height: 55px;
    /* identical to box height */

    text-align: center;

    color: #313131;
  }

  .login-below {
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .otp-login-box {
    padding-top: 40px;
  }

  .Otp-continue-btn {
    padding-top: 30px;
    margin-left: 60px;
  }

  .otpContainer {
    display: flex;
    justify-content: center;
    gap: 30px;

    input {
      font-family: 'Satoshi-Medium';
      font-style: normal;
      font-weight: 500;
      font-size: 36px;
      line-height: 45px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #313131;
    }
  }

  .doctor-error-msg {
    margin-top: 6px;
    margin-left: 6px;
    // background-color: #fee6e6;
    padding: 3px;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    color: #b11b1b;
    width: 85%;
    margin: 0 auto;

    .bsX {
      cursor: pointer;
      margin-top: 2px;
      font-size: 20px;
    }
  }

  .input-otp-error {
    input {
      border: 1px solid #bc0001 !important;
      color: #bc0001;
    }
  }
  @media only screen and (max-width: 767px) {
    .heading-confirm h3 {
      font-size: 20px;
      line-height: 27px;
      margin-top: 25px;
      justify-content: center;
    }
    .otp-login-box {
      padding-top: 0px;
    }
    .doctor-error-msg p {
      justify-content: space-between;
      font-family: 'Satoshi-Medium';
      font-style: normal;
      font-weight: 450;
      font-size: 15px;
      line-height: 150%;
      display: flex;
      align-items: center;
      color: #bc0001;
      margin-top: 7px;
      word-spacing: -3px;
     
    }
    .otpContainer input {
      width: 44px !important;
      height: 44px !important;
      border-radius: 5px !important;
      font-family: 'Satoshi-medium';
      font-weight: 450;
      font-size: 22px;
      line-height: 150%;
    }
  }
`;

export default DoctorSignInOtp;
